import { render } from "./HomeModalAlbumPicker.vue?vue&type=template&id=2e3d5561"
import script from "./HomeModalAlbumPicker.vue?vue&type=script&lang=js"
export * from "./HomeModalAlbumPicker.vue?vue&type=script&lang=js"
script.render = render

export default script